module.exports = __webpack_public_path__ + "static/media/my-account-bg-water.b5a0d11d.jpg";